module.exports = __webpack_public_path__ + "img/jd_logo.349766e.349766ea.jpg";